import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logo-view" }
const _hoisted_2 = { class: "container-login" }
const _hoisted_3 = { class: "label-view" }
const _hoisted_4 = { class: "label-view" }
const _hoisted_5 = { class: "input-view" }
const _hoisted_6 = { class: "label-view" }
const _hoisted_7 = { class: "input-view" }
const _hoisted_8 = { class: "label-view" }
const _hoisted_9 = { class: "input-view" }
const _hoisted_10 = {
  style: {"padding-top":"20px","padding-bottom":"20px"},
  class: "dont-accrount"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "signup-wrapper" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_img, {
              class: "logo-img",
              src: require('@/assets/images/logo_multismall.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.mailOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, {
                    slot: "end",
                    class: "label-style",
                    position: "stacked"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Email ")
                    ])),
                    _: 1,
                    __: [7]
                  })
                ]),
                _createVNode(_component_ion_input, {
                  placeholder: 'example@gmail.com',
                  modelValue: _ctx.state.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event)),
                  autofocus: "",
                  class: "ion-check-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.v$.email.$error)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.v$.email.$errors, (error, idx) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "error-message",
                    key: idx.toString(),
                    style: {"color":"red"}
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, { style: {"margin-top":"25px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.lockClosedOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, {
                    class: "label-style",
                    position: "stacked"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Username")
                    ])),
                    _: 1,
                    __: [8]
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_ion_input, {
                    type: "text",
                    placeholder: '@jane_doe',
                    modelValue: _ctx.state.profile.nickName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.profile.nickName) = $event)),
                    onIonBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formatNickname())),
                    autofocus: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            (_ctx.v$.profile.nickName.$error)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.v$.profile.nickName.$errors, (error, idx) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "error-message",
                    key: idx.toString()
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, { style: {"margin-top":"25px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.lockClosedOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, {
                    class: "label-style",
                    position: "stacked"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" Password")
                    ])),
                    _: 1,
                    __: [9]
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_ion_input, {
                    type: _ctx.passwordType,
                    placeholder: '******',
                    modelValue: _ctx.state.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.password) = $event)),
                    autofocus: ""
                  }, null, 8, ["type", "modelValue"]),
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.passwordIcon,
                    onClick: _ctx.changePasswordType,
                    color: "black"
                  }, null, 8, ["icon", "onClick"])
                ])
              ]),
              _: 1
            }),
            (_ctx.v$.password.$error)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.v$.password.$errors, (error, idx) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "error-message",
                    key: idx.toString()
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, { style: {"margin-top":"25px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.lockClosedOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, {
                    class: "label-style",
                    position: "stacked"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(" Confirm Password ")
                    ])),
                    _: 1,
                    __: [10]
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ion_input, {
                    type: _ctx.confirmPasswordType,
                    placeholder: 'Re-type your password ',
                    modelValue: _ctx.state.confirmPassword,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.confirmPassword) = $event)),
                    autofocus: ""
                  }, null, 8, ["type", "modelValue"]),
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.confirmPasswordIcon,
                    onClick: _ctx.changeConfirmPasswordType,
                    color: "black"
                  }, null, 8, ["icon", "onClick"])
                ])
              ]),
              _: 1
            }),
            (_ctx.v$.confirmPassword.$error)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.v$.confirmPassword.$errors, (error, idx) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "error-message",
                    key: idx.toString()
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_button, {
              class: "login-btn",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.signup())),
              disabled: _ctx.isLoading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_text, null, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" Register")
                      ])),
                      _: 1,
                      __: [11]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_10, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-16-300" }, "Already Have Account?", -1)),
              _createElementVNode("a", {
                onClick: _cache[6] || (_cache[6] = () => _ctx.router.push('/login'))
              }, " Login ")
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}